import React from 'react';
import { Badge, CIRCLE_NUMS, STRING_COLORS_LIGHT, DEFAULT_NOTE_COLOR } from '../../../types/fingeringEditor';

interface ChordNotePickerProps {
  chordNotes: Badge[];
  position: { x: number; y: number };
  onSelectNote: (badgeId: number) => void;
  onAddNote: () => void;
  onClose: () => void;
  showAddOption: boolean;
}

const ChordNotePicker: React.FC<ChordNotePickerProps> = ({
  chordNotes, position, onSelectNote, onAddNote, onClose, showAddOption,
}) => {
  return (
    <>
      <div className="fixed inset-0 z-40" onPointerDown={onClose} />
      <div
        className="fixed z-50 bg-slate-800 border border-slate-600 rounded-xl shadow-2xl shadow-black/60 py-2 min-w-[160px]"
        style={{ left: position.x, top: position.y, transform: 'translate(-50%, -100%) translateY(-8px)' }}
      >
        <div className="text-[10px] text-slate-500 font-semibold tracking-wider px-3 pb-1.5 border-b border-slate-700">
          編集する音を選択
        </div>
        {chordNotes.map((note) => {
          const color = note.string ? (STRING_COLORS_LIGHT[note.string] ?? DEFAULT_NOTE_COLOR) : DEFAULT_NOTE_COLOR;
          return (
            <button
              key={note.id}
              onClick={() => onSelectNote(note.id)}
              className="w-full flex items-center gap-2.5 px-3 py-2 hover:bg-slate-700/60 transition-colors text-left"
            >
              <span
                className="w-5 h-5 rounded-full flex items-center justify-center text-[11px] font-bold text-white"
                style={{ background: color }}
              >
                {note.string != null ? CIRCLE_NUMS[note.string - 1] : '?'}
              </span>
              <span className="text-sm text-slate-300 font-medium">
                {note.note || '未設定'}
              </span>
              {note.fret != null && (
                <span className="text-sm text-slate-500 ml-auto" style={{ color }}>
                  {note.fret}
                </span>
              )}
            </button>
          );
        })}
        {showAddOption && (
          <>
            <div className="border-t border-slate-700 my-1" />
            <button
              onClick={onAddNote}
              className="w-full flex items-center gap-2.5 px-3 py-2 hover:bg-amber-900/30 transition-colors text-left"
            >
              <span className="w-5 h-5 rounded-full flex items-center justify-center text-[13px] font-bold text-amber-400 border border-amber-500/50">
                +
              </span>
              <span className="text-sm text-amber-400 font-medium">＋ 音を追加</span>
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default ChordNotePicker;
